module.exports = __webpack_public_path__ + "img/议.270f4a4e.svg";